import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { CartProvider } from "./context/CartContext";
import { WishlistProvider } from "./context/WishlistContext";
import { SettingsProvider } from "./context/SettingsContext";
import { ContentProvider } from "./context/ContentContext";
import { AuthProvider, useAuth } from "./context/AuthContext";

import StoreLayout from "./components/storefront/StoreLayout";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import ProductDetail from "./pages/ProductDetail";
import Histoire from "./pages/Histoire";
import Contact from "./pages/Contact";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation";
import CGV from "./pages/CGV";
import Favoris from "./pages/Favoris";
import Suivi from "./pages/Suivi";
import AdminAlerts from "./pages/admin/AdminAlerts";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminCollections from "./pages/admin/AdminCollections";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminInventory from "./pages/admin/AdminInventory";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminContent from "./pages/admin/AdminContent";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex h-screen items-center justify-center text-[#9B7E73]">Chargement...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <ContentProvider>
        <AuthProvider>
          <CartProvider>
          <WishlistProvider>
            <BrowserRouter>
              <Toaster position="top-center" richColors />
              <Routes>
                <Route element={<StoreLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/catalog" element={<Catalog />} />
                  <Route path="/produit/:id" element={<ProductDetail />} />
                  <Route path="/histoire" element={<Histoire />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/panier" element={<Cart />} />
                  <Route path="/commande" element={<Checkout />} />
                  <Route path="/commande/confirmation/:numero" element={<OrderConfirmation />} />
                  <Route path="/cgv" element={<CGV />} />
                  <Route path="/favoris" element={<Favoris />} />
                  <Route path="/suivi" element={<Suivi />} />
                </Route>

                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="produits" element={<AdminProducts />} />
                  <Route path="collections" element={<AdminCollections />} />
                  <Route path="commandes" element={<AdminOrders />} />
                  <Route path="inventaire" element={<AdminInventory />} />
                  <Route path="parametres" element={<AdminSettings />} />
                  <Route path="contenu" element={<AdminContent />} />
                  <Route path="alertes" element={<AdminAlerts />} />
                </Route>

                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
          </WishlistProvider>
          </CartProvider>
        </AuthProvider>
        </ContentProvider>
      </SettingsProvider>
    </div>
  );
}

export default App;
